'use strict';


module.exports = function ( config ) {
    var ids = require('../identifiers'),
        gettext = require('mag-gettext').gettext,
        forceDviVarName = 'force_dvi',
        environment = {};

    environment[forceDviVarName] = '0';

    return {
        id: 'digitalOutput',
        advanced: true,
        name: gettext('HDMI/DVI'),
        title: gettext('HDMI/DVI'),
        description: [
            {
                label: gettext('HDMI/DVI'),
                value: core.environment[forceDviVarName] === '0' ? 'HDMI' : 'DVI'
            }
        ],
        icon: 'theme-icon-display',
        environment: environment,
        prepareForRender: function ( env, callback ) {
            var enabled = env[forceDviVarName] === '1',
                options = [
                    {value: '0', name: gettext('HDMI'), selected: !enabled},
                    {value: '1', name: 'DVI', selected: enabled}
                ];

            callback(options);
        },
        prepareForSave: function ( value, callback) {
            this.environment[forceDviVarName] = value;

            callback();
        },
        requireDeviceReboot: true,
        render: config.api.renders.popupSelect,
        getter: config.api.getters.environment,
        saver: config.api.savers.environment,
        parent: ids.video
    };
};
